import type { AxiosResponse } from 'axios'
import type { DatePolicyWarning } from '../types/api'

/**
 * Parses standard academics success envelopes: `{ data, date_policy_warnings?, message? }`
 * or a bare resource when `data` is omitted.
 */
export function unwrapAcademicsMutation<T>(res: AxiosResponse): {
  data: T
  date_policy_warnings?: DatePolicyWarning[]
  message?: string
} {
  const body = res.data as {
    data?: T
    date_policy_warnings?: DatePolicyWarning[]
    message?: string
  }
  const data = (body.data !== undefined ? body.data : res.data) as T
  return {
    data,
    date_policy_warnings: body.date_policy_warnings,
    message: body.message,
  }
}
